import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getProjects, getProjectForms } from '../../services/projectService';
import { getFormWidgets } from '../../services/formService';
import { WidgetTypes } from '../../constants/QuestionTypes';
import _ from 'lodash';
import { stripTags } from '../common/commonFuncs';
import CustomLoader from '../common/Loader';
import * as Icon from 'react-feather';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import { logActivity } from '../../services/utilService';
import ReportSettings from './ReportSettings';
import { ExitStatus } from 'typescript';

class DisplayMetrics extends Component {
    constructor(props) {
        super(props);

        this.state = {
            preloadData: this.props.preloadData ? this.props.preloadData : undefined,
            loading: false,
            reportDatatableOptions: {
                enableServerSidePaging: false,
                enableDownloadDT: false,
                enablePrintDT: false,
                enableFilterDT: false,
            }
        };
    }

    componentDidMount() {
        this.inputChangeEvent = this.inputChangeEvent.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.handleSave = this.handleSave.bind(this);
        // this.loadProjects().
        //     // then(this.loadReports).
        //     then(this.fillPreloadData).
        //     then(this.setState({ loading: false }));
    }

    fillPreloadData = async () => {
        if (this.state.preloadData) {
            let preloadDataObj = this.state.preloadData,
                reportSelected = {
                    'reportID': preloadDataObj[0],
                    'reportName': preloadDataObj[1],
                    'reportDesc': preloadDataObj[2],
                    'projectID': preloadDataObj[3],
                    'projectName': preloadDataObj[4]
                };
            this.setState({ reportSelected });
        }
        Promise.resolve('success');
    }

    inputChangeEvent(e) {
        let reportSelected = this.state.reportSelected, inputData = e.target;
        reportSelected[inputData.name] = inputData.value;
        this.setState({ reportSelected });
    }

    clearFields() {
        let reportSelected = this.state.reportSelected;
        reportSelected['reportName'] = '';
        reportSelected['reportDesc'] = '';
        reportSelected['projectID'] = this.state.projects ? this.state.projects[0]['Project_ID'] : 0;
        this.setState({ reportSelected });
    }

    handleSave() {
        let reportSelected = this.state.reportSelected, isvalid = Object.keys(reportSelected).length > 0;
        if (Object.keys(reportSelected).length > 0) {
            /* Form Validation */
            for (const key in reportSelected) {
                if (reportSelected[key] !== '' && reportSelected[key] !== undefined) { continue; }
                else {
                    if (key !== 'reportDesc') {
                        isvalid = false;
                        break;
                    }
                }
            }
            if (isvalid) {
                try {
                    //API to save Report
                    console.log(reportSelected);

                    let data = {};
                    if (typeof data === 'string') {
                        throw new Error('error');
                    }
                    else {
                        toaster('success', 'Report Saved successfully.')
                    }
                }
                catch (e) {
                    toaster('error', 'Oops! Cannot Save form at this time. Please try again later.')
                }
            }
            else {
                toaster('warning', 'Please fill required Details for saving!')
            }
        }
        else {
            toaster('warning', 'Please fill required Details for saving!')
        }
    }

    render() {
        const { preloadData, reportDatatableOptions } = this.state;

        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading }
            else {
                return (
                    <React.Fragment>
                        <div className='card card-header-actions'>
                            <div className='card-body'>
                                <div className='align-items-center justify-content-between'>
                                    <h4 className='ml-3'>DataTable Options</h4>
                                    <div className='row ml-1'>
                                        <div className="col-md-2 form-group">
                                            <div className="custom-control custom-switch mt-n2">
                                                <input
                                                    type="checkbox"
                                                    name='enableServerSidePaging'
                                                    id={'rowEnableServerSidePagingSwitch' + 'Widget_ID'}
                                                    className="custom-control-input"
                                                    checked={reportDatatableOptions.enableServerSidePaging}
                                                    value={reportDatatableOptions.enableServerSidePaging}
                                                    onChange={(e) => this.handleCheck(e.target)}
                                                />
                                                <br />
                                                <label htmlFor={'rowEnableServerSidePagingSwitch' + 'Widget_ID'} className="custom-control-label">Server-Side Paging</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2 form-group">
                                            <div className="custom-control custom-switch mt-n2">
                                                <input
                                                    type="checkbox"
                                                    name='enableDownloadDT'
                                                    id={'rowEnableSDownloadDTSwitch' + 'Widget_ID'}
                                                    className="custom-control-input"
                                                    checked={reportDatatableOptions.enableDownloadDT}
                                                    value={reportDatatableOptions.enableDownloadDT}
                                                    onChange={(e) => this.handleCheck(e.target)}
                                                />
                                                <br />
                                                <label htmlFor={'rowEnableSDownloadDTSwitch' + 'Widget_ID'} className="custom-control-label">Download Table</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2 form-group">
                                            <div className="custom-control custom-switch mt-n2">
                                                <input
                                                    type="checkbox"
                                                    name='enablePrintDT'
                                                    id={'rowEnableSPrintDTSwitch' + 'Widget_ID'}
                                                    className="custom-control-input"
                                                    checked={reportDatatableOptions.enablePrintDT}
                                                    value={reportDatatableOptions.enablePrintDT}
                                                    onChange={(e) => this.handleCheck(e.target)}
                                                />
                                                <br />
                                                <label htmlFor={'rowEnableSPrintDTSwitch' + 'Widget_ID'} className="custom-control-label">Print Table</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2 form-group">
                                            <div className="custom-control custom-switch mt-n2">
                                                <input
                                                    type="checkbox"
                                                    name='enableFilterDT'
                                                    id={'rowEnableFilterDTSwitch' + 'Widget_ID'}
                                                    className="custom-control-input"
                                                    checked={reportDatatableOptions.enableFilterDT}
                                                    value={reportDatatableOptions.enableFilterDT}
                                                    onChange={(e) => this.handleCheck(e.target)}
                                                />
                                                <br />
                                                <label htmlFor={'rowEnableFilterDTSwitch' + 'Widget_ID'} className="custom-control-label">Filter Table</label>
                                            </div>
                                        </div>
                                    </div>
                                </div><br />
                                <div className='row ml-2'>
                                    <button className='btn btn-primary ml-2' onClick={this.handleSave}>Save</button>
                                </div>
                            </div>
                        </div>
                        <ToastContainer />
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Add Report: ', e);
            return (loading);
        }
    }
}

export default withRouter(DisplayMetrics);